import React from "react"
import { useOrder } from "context/order"
import { useLocale } from "context/locale"
import Button from "components/Button"

import StyledInstruction from "./styles"

const Instruction = () => {
  const { t } = useLocale()
  const { show_form, handleShowForm, scrollTo } = useOrder()
  return (
    <StyledInstruction show_form={show_form}>
      <div className="main-container">
        <div className="order-courier__wrapper">
          <p className="order-courier__header">
            {t(
              "3 steps that separate you from giving your clothes a second life:"
            )}
            :
          </p>
          <div className="order-courier__row">
            <div className="order-courier__col">
              <div className="order-courier__item">
                <div>
                  <p className="order-courier__item-number bolder">1</p>
                  <p className="order-courier__item-header bolder">
                    {t("Choose the clothes you want to give away")}
                  </p>
                </div>
                <div className="order-courier__item-desc">
                  <p>
                    {t(
                      "You can donate all kind of clothes – women’s, men’s, children’s, in all sizes and colors. Just make sure they are clean and not too used, i.e. they don’t have holes and permanent stains that cannot be removed."
                    )}
                  </p>
                  <strong>
                    {t(
                      "We collect garments from all brands, not only 4F, so give away all the clothes that can be given a second life."
                    )}
                  </strong>
                </div>
              </div>
            </div>
            <div className="order-courier__col">
              <div className="order-courier__item">
                <div>
                  <p className="order-courier__item-number bolder">2</p>
                  <p className="order-courier__item-header bolder">
                    {t("Pack your clothes")}
                  </p>
                </div>
                <div className="order-courier__item-desc">
                  <p>
                    {t(
                      "Pack your clothes into a cardboard box – its dimensions should be similar to a cabin luggage – and close it properly. But before sending it, double check your closet! Maybe you’ve got more clothes that you don’t wear than just this one hoodie or pants? Maybe your family or friends would also like to clean out their wardrobes and give the unwanted clothes a second life? It would be definitely much better from the planet’s point of view if the courier didn’t have to come twice!"
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="order-courier__col">
              <div className="order-courier__item">
                <div>
                  <p className="order-courier__item-number bolder">3</p>
                  <p className="order-courier__item-header bolder">
                    {t("Order a free courier")}
                  </p>
                </div>
                <div className="order-courier__item-desc">
                  <p>
                    {t(
                      "Fill in the form below and order a free courier that will pick up the parcel from you. You only need to provide your address and the pick-up date. Don’t worry if you can’t print out the shipping label – the courier will bring it."
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="order-courier__mobile-button">
          <Button
            type="button"
            text={t("Fill in the form")}
            onClick={() => {
              handleShowForm(true)
              setTimeout(() => {
                scrollTo("#order_form")
              }, 200)
            }}
          />
        </div>
      </div>
    </StyledInstruction>
  )
}

export default Instruction
